import { Component, OnInit,OnDestroy, AfterViewInit, ViewContainerRef,ViewChild, Renderer2 } from '@angular/core';
import { HttpClient, HttpResponse, HttpHeaders } from '@angular/common/http';
import { ActivatedRoute, Router } from '@angular/router';
import { Modal } from 'angular2-modal/plugins/bootstrap';
import { IMyDpOptions } from 'mydatepicker';
import { ToastrService } from 'ngx-toastr';
import { Subscription } from 'rxjs';
import { EchexpaymentService } from '../echexpayment.service';
import { LocalstorageService } from '../localstorage.service';
import { UserService } from '../user.service';
import {DataTableModule} from "angular2-datatable";
// import {DataTablesModule} from "angular-datatables";
import { Constants } from '../app.constants';
import { ScriptService } from "../script.service";
declare var Plaid: any;
class DataTablesResponse {
    data: any[];
    draw: number;
    recordsFiltered: number;
    recordsTotal: number;
}

@Component({
  	selector: 'app-transactions',
  	templateUrl: './transactions.component.html',
  	styleUrls: ['./transactions.component.css'],
  	providers: [Modal]
})

export class TransactionsComponent implements OnInit, OnDestroy, AfterViewInit {
    public transaction: any = {};
    public advancedata: any = {};
    public advanceFilterdata: any = {
        Customfilter: '',
        Selectfilter: '',
        Entryfilter: '',
        Recuringfilter: ''
    };
    public Transtscationdata: any = {};
    public merchantUserTransaction: {};
    public merchantTransaction: {};
    public token: string;
    public user_token: string;
    public id: string;
    public role_id: string;
    public merchant_token: string;
    public toggle : boolean = false;
    public alltoggle;
    public search_total_cheque = 0;
    public search_total_cheque_amount = 0;
    busy: Subscription;
    public searchData;
    public dataNotFound: boolean = false;
    public data;
    public filterQuery = "";
    public rowsOnPage = 50;
    public sortBy = "created_at";
    public total_cheque = 0;
    public total_cheque_amount = 0;
    public sortOrder = "desc";
    public DateValidate: string;
    public myDatePickerOptions: IMyDpOptions = {
        dateFormat: 'dd/mm/yyyy',
        editableDateField: false
    };
    public selectedIds: string[] = [];
    public Mer_User_Prientcheck: boolean = false;
    public checkRouting: string;
    public checkRoutingno: string;
    private actionUrl: string;
    public currentTab = "Search Check";

    public showDirectDepositBtn: boolean = false;
    public direcDepositSettings: string;
    public jsonReponseTxt: string;
    // Plaid variable
    linkHandler: any;
    public plaid_link_token: string;
    selectedItems: any[] = [];

    @ViewChild('mf') mfDataTable: DataTableModule;
    mfData_Tables: any;
    constructor(protected router: Router, private renderer: Renderer2, protected route: ActivatedRoute, private toastr: ToastrService, protected userService: UserService, protected echexpaymentService: EchexpaymentService, protected localStorageService: LocalstorageService, vcRef: ViewContainerRef, public modal: Modal, private http: HttpClient , private _constants: Constants, private scriptService: ScriptService) {
        this.actionUrl = _constants.ServerWithApiUrl;
        this.router = router;
        var currentUser = this.localStorageService.getData("currentUserToken");
        this.token = currentUser.data.user_token;
        let userDetails = this.localStorageService.getData("currentUser");
        // this.Mer_User_Prientcheck = userDetails && userDetails.settings.permissions.PrintCheck;
        this.Mer_User_Prientcheck = userDetails && (userDetails.settings.permissions.PrintCheck === 'no' ? true : false);
        this.id = userDetails._id;
        this.role_id = userDetails.role_id;
        this.merchant_token = userDetails.merchant_token;
		
        if (this.role_id == '3') {
            this.getMerchantUser(this.merchant_token) ;
        }
        if (this.role_id == '1' || this.role_id == '2') {
            this.getAllMerchantForDropDown();
        }
    }

    ngOnDestroy() {
        this.toastr.clear();
    }

    ngOnInit() {
        this.getAllMerchantForDropDown();
        this.showHideDepositOption();
    }

    showHideDepositOption() {
        let checkDirectDepositData = <any>{};
        let data = {
            merchant_id: this.merchant_token,
            user_token: this.token
        };

        this.echexpaymentService.checkDirectDepositWithMerchant(data)
            .subscribe(
                response => {
                    checkDirectDepositData = response;
                    this.showDirectDepositBtn = checkDirectDepositData.data.direct_deposit;
                    this.direcDepositSettings = checkDirectDepositData.data.automatic_type;
                },
                error => {
                    checkDirectDepositData = error;
                    this.toastr.error(
                        checkDirectDepositData.error.message,
                        "Failed!"
                    );
                }
            );
    }

    handleTabClick(tabTitle: string) {
        this.currentTab = tabTitle;
        if (tabTitle === 'Search Check') {
            this.filterQuery = '';
            this.advanceFilterdata = {
                Customfilter: '',
                Selectfilter: '',
                Entryfilter: '',
                Recuringfilter: ''
            };
            this.advancedata = {};
            this.getAllTransactionAdvance();
        }
        if (tabTitle === 'Advanced Search') {
            this.filterQuery = '';
            this.advanceFilterdata = {
                Customfilter: '',
                Selectfilter: '',
                Entryfilter: '',
                Recuringfilter: ''
            };
            this.advancedata = {};
            this.advancedata.from_date = '';
            this.advancedata.to_date = '';
            this.getAllTransactionAdvance();
        }
    }


    // sortSelectedIds() {
    //     this.selectedIds.sort((a, b) => {
    //         const itemA = this.data.find(item => item.id === a);
    //         const itemB = this.data.find(item => item.id === b);
    //         return itemA.created_at.localeCompare(itemB.created_at);
    //     });
    // }


    toggleAll() {
        this.selectedItems = this.toggle ? [...this.data] : [];
        this.data.forEach((item) => (item.checked = this.toggle));
      }
    
      toggleItem(item: any) {
        if (item.checked) {
          this.selectedItems.push(item);
        } else {
          this.selectedItems = this.selectedItems.filter((x) => x.id !== item.id);
        }
        this.toggle = this.data.every((item) => item.checked);
      }


    getAllMerchantForDropDown() {
        var data = {
            user_token: this.token,
            token: this.id,
            _id: this.id
        }
        let responseData = < any > {};
        this.echexpaymentService.getAllMerchantForDropDownApi(data).subscribe(
            response => {
                responseData = response;
                this.merchantTransaction = responseData.data
            },
            error => {
                responseData = error;
                this.toastr.error(responseData.error.message, 'Failed!');
            }
        );
    }

    getMerchantUser(echex_merchant_token) {
        var data = {
            user_token: this.token,
            token: this.id,
            _id: this.id,
            echex_merchant_token: echex_merchant_token
        }
        let responseData = < any > {};
        this.echexpaymentService.getMerchantUserApi(data).subscribe(
            response => {
                responseData = response;
                this.merchantUserTransaction = responseData.data;
                this.advancedata.marchent_admin_user = '';
            },
            error => {
                responseData = error;
                this.toastr.error(responseData.error.message, 'Failed!');
            }
        );
    }


    printForBankDeposit(model) {
        const ids = this.selectedItems.map((record) => record.id);

        if (!ids.length) {
            var message = 'Please select at least one Check.';
            this.toastr.error(message, 'Failed!');
            return;
        }

        var data = {
            cheque_id: ids,
            user_token: this.token,
            token: this.id,
            _id: this.id,
        };

        var googleWindow = window.open();
        this.busy = this.echexpaymentService.printForBankDepositApi(data).subscribe(
            (res) => {
                var file = new Blob([res], {
                    type: "application/pdf"
                });
                var fileURL = URL.createObjectURL(file);
                googleWindow.location.replace(fileURL);
            }
        );
    }

    printForMobileApp(model) {
        const ids = this.selectedItems.map((record) => record.id);

        if (!ids.length) {
            var message = 'Please select at least one Check.';
            this.toastr.error(message, 'Failed!');
            return;
        }

        let params: any = this.route.snapshot.params;
        var data = {
            cheque_id: ids,
            user_token: this.token,
            token: this.id,
            _id: this.id
        };
        var googleWindow = window.open();
        let responseData = < any > {};
        this.busy = this.echexpaymentService.printForMobileAppApi(data).subscribe(
            (res) => {
                var file = new Blob([res], {
                    type: "application/pdf"
                });
                var fileURL = URL.createObjectURL(file);
                googleWindow.location.replace(fileURL);

            },
            error => {
                responseData = error;
                this.toastr.error(responseData.error.message, 'Failed!');
            }
        );

    }

    handleDateInput(event: Event) {
        event.preventDefault();
    }

    clearDate() {
        this.DateValidate = "";
        this.advancedata.from_date = '';
        this.advancedata.to_date = '';
        this.getAllTransactionAdvance();
    }
    // get transcation data for advanced tab
    getAllTransactionAdvance(model: any = {}, search_but: any = '') {
        this.dataNotFound = false;
        model.is_printed = this.advanceFilterdata.Selectfilter;
        model.custom_day = this.advanceFilterdata.Customfilter;
        model.cheque_type = this.advanceFilterdata.Entryfilter;
        model.recurrent = this.advanceFilterdata.Recuringfilter;
        model.echex_merchant_token = this.advancedata.echex_merchant_token;
        model.marchent_admin_user = this.advancedata.marchent_admin_user;
        if (search_but === 1) {
            //date validate
            const fromDate = this.advancedata.from_date && this.advancedata.from_date.jsdate ? new Date(this.advancedata.from_date.jsdate) : null;
            const toDate = this.advancedata.to_date && this.advancedata.to_date.jsdate ? new Date(this.advancedata.to_date.jsdate) : null;
            const currentDate = new Date(); // Get the current date
            currentDate.setHours(0, 0, 0, 0);
            if (fromDate && toDate && fromDate.getTime() === toDate.getTime()) {
                this.DateValidate = "From date and To date cannot be the same.";
                //   return;
            } else if (fromDate && toDate && fromDate > toDate) {
                this.DateValidate = "From date must be less than the To date.";
                return;
            } else if (fromDate && toDate && fromDate == null || toDate == null) {
                this.DateValidate = "For Search Select - From date and To Date";
                return;
            } else {
                this.DateValidate = "";
            }

            if (toDate > currentDate) {
                this.DateValidate = "To date must be less than or equal to the current date.";
                return;
            } else {
                this.DateValidate = "";
            }
            this.advanceFilterdata.Customfilter = '';
            model.custom_day = '';
        } else if (this.advanceFilterdata.Customfilter) {
            this.advancedata.from_date = '';
            this.advancedata.to_date = '';
        }

        model._id = this.id;
        model.token = this.id;
        model.user_token = this.token;

        if (Object.keys(this.advancedata).length > 0) {
            model.from_date = this.advancedata.from_date && this.advancedata.from_date.formatted;
            model.to_date = this.advancedata.from_date && this.advancedata.to_date.formatted;
        }
    

        if(this.currentTab === 'Search Check') {
            var datatable = $('#main-datatable').DataTable();
            datatable.destroy();

            $('#main-datatable').DataTable({
                pagingType: 'full_numbers',
                pageLength: 25,
                serverSide: true,
                processing: false,
                destroy: true,
                order: [[1, 'desc']],
                language: {
                    searchPlaceholder: "Name, Memo..."
                },
                ajax: (dataTablesParameters: any, callback) => {
                    var data = {
                        user_token: this.token,
                        token: this.id,
                        _id: this.id
                    }

                    let params = new URLSearchParams();
                    const headers = new HttpHeaders().set('Authorization', `Bearer ${data.user_token}`);  
                    let resp_data = < any > {};
                    dataTablesParameters = {...dataTablesParameters, ...model};
                    this.busy = this.http.post<DataTablesResponse>(
                        this.actionUrl +'lists/cheque/datatable/'+data._id,
                        dataTablesParameters,
                        {headers}
                    ).subscribe(resp => {
                        resp_data = resp.data;
                        this.data = resp_data.data;

                        this.total_cheque = resp_data.recordsTotal;
                        this.total_cheque_amount = resp_data.total_amount;

                        callback({
                            recordsTotal: resp_data.recordsTotal,
                            recordsFiltered: resp_data.recordsFiltered,
                            data: []
                        });
                    });
                },
                columns: [{ data: 'id' }, { data: 'created_at' }, { data: 'name' },{ data: 'memo' }, { data: 'cheque_amount' }, { data: 'cheque_type' },{ data: 'is_printed' }, { data: 'check_recurrent_enable' }, { data: 'action' }],
                columnDefs: [ {
                    'targets': [0,5,6,7,8], // column index (start from 0)
                    'orderable': false, // set orderable false for selected columns
                }]
            });
        } else {
            var datatable = $('#advance-datatable').DataTable();
            datatable.destroy();

            $('#advance-datatable').DataTable({
                pagingType: 'full_numbers',
                pageLength: 25,
                serverSide: true,
                processing: false,
                destroy: true,
                order: [[1, 'desc']],
                language: {
                    searchPlaceholder: "Name, Memo..."
                },
                ajax: (dataTablesParameters: any, callback) => {
                    var data = {
                        user_token: this.token,
                        token: this.id,
                        _id: this.id
                    }

                    let params = new URLSearchParams();
                    const headers = new HttpHeaders().set('Authorization', `Bearer ${data.user_token}`);  
                    let resp_data = < any > {};
                    dataTablesParameters = {...dataTablesParameters, ...model};
                    this.busy = this.http.post<DataTablesResponse>(
                        this.actionUrl +'lists/cheque/datatable/'+data._id,
                        dataTablesParameters,
                        {headers}
                    ).subscribe(resp => {
                        resp_data = resp.data;
                        this.data = resp_data.data;

                        this.search_total_cheque = resp_data.recordsTotal;
                        this.search_total_cheque_amount = resp_data.total_amount;

                        callback({
                            recordsTotal: resp_data.recordsTotal,
                            recordsFiltered: resp_data.recordsFiltered,
                            data: []
                        });
                    });
                },
                columns: [{ data: 'id' }, { data: 'created_at' }, { data: 'name' },{ data: 'memo' }, { data: 'cheque_amount' }, { data: 'cheque_type' },{ data: 'is_printed' }, { data: 'check_recurrent_enable' }, { data: 'action' }],
                columnDefs: [ {
                    'targets': [0,5,6,7,8], // column index (start from 0)
                    'orderable': false, // set orderable false for selected columns
                }]
            });
        }
    }

    // loadPopUp
    loadPopUp() {
        let data = { user_token: this.token };
        let responseData = <any>{};
        this.busy = this.userService.ConectBankV2(data).subscribe(response => {
            responseData = response;
            this.plaid_link_token = responseData.data.link_token;
            this.linkHandler = Plaid.create({
                token: this.plaid_link_token,
                onSuccess: function(public_token, metadata) {
                    (document.getElementById(
                        "publictoken"
                    ) as HTMLInputElement).value = public_token;
                    var l = document.getElementById("submitToGetInfo");
                    l.click();
                },
                onExit: function(err, metadata) {
                    // The user exited the Link flow.
                    if (err != null) {
                    }
                }
            });
        });
    }

    // get info from Plaid
    getInfoFromPlaid() {
        var public_token = (document.getElementById(
            "publictoken"
        ) as HTMLInputElement).value;
        var data = {
            PlaidInfo: true,
            token: public_token,
            amount: 1
        };
        let responseData = <any>{};
        this.busy = this.echexpaymentService
            .getInfoFromPlaidApi(data)
            .subscribe(
                response => {
                    responseData = response;
                    this.saveDepositInformation(responseData.data);
                },
                error => {
                    responseData = error;
                    this.toastr.error(responseData.error.message, 'Failed!');
                }
            );
    }

    // get info from Plaid
    saveDepositInformation(response_data) {
        const ids = this.selectedItems.map((record) => record.id);

        let params: any = this.route.snapshot.params;
        var data = response_data;
        data.cheque_id = ids;
        data.direct_deposit = this.showDirectDepositBtn;
        data.automatic_type = this.direcDepositSettings;
        data.transaction_type = 2;
        let responseData = <any>{};
        this.busy = this.echexpaymentService
            .saveDepositCustomerInfo(data)
            .subscribe(
                response => {
                    responseData = response;
                    if(responseData.status_code == 401) {
                        this.toastr.error(responseData.message, 'Failed!');
                    } else {
                        this.toastr.success('Deposited successfully', 'Success!');
                    }
                    console.log(responseData.data);
                    this.jsonReponseTxt = JSON.stringify(responseData.data);
                    this.toastr.info(this.jsonReponseTxt, 'Info!');
                    this.getAllTransactionAdvance();
                    this.selectedItems = [];
                },
                error => {
                    responseData = error;
                    this.toastr.error(responseData.error.message, 'Failed!');
                }
            );
    }

    // Open Plaid popup
    ConnectBank() {
        const ids = this.selectedItems.map((record) => record.id);

        if (!ids.length) {
            var message = 'Please select at least one Check.';
            this.toastr.error(message, 'Failed!');
            return;
        }

        // if (ids.length > 1) {
        //     var message = 'Please select only one Check for deposit.';
        //     this.toastr.error(message, 'Failed!');
        //     return;
        // }

        this.linkHandler.open();
    }

    ngAfterViewInit() {
        setTimeout(() => {
            this.handleTabClick('Search Check');
        }, 1);

        this.scriptService
            .load("Plaid")
            .then(data => {
                this.loadPopUp();
            })
            .catch(error => console.log(error));
    }
}



// WEBPACK FOOTER //
// C:/xampp/htdocs/projects/angular.casherpay.stgnew/angular.casherpay/src/app/transactions/transactions.component.ts